import React from "react";
import "./index.less";

interface HiddenSeoContentProps {
  children: React.ReactNode;
}

const HiddenSeoContent: React.FC<HiddenSeoContentProps> = ({ children }) => {
  return (
    <details className="hidden-seo-content">
      <summary style={{ listStyle: "none" }}></summary>
      <div className="seo-content-wrapper">
        {children}
      </div>
    </details>
  );
};

export default HiddenSeoContent;
